import { useIsomorphicLayoutEffect } from "@tamagui/constants";
import { useState } from "react";
import {
  useWindowDimensions as useWindowDimensionsRN
} from "react-native";
const initialValue = {
  fontScale: 1,
  height: 800,
  width: 600,
  scale: 1
};
function useWindowDimensions() {
  const current = useWindowDimensionsRN();
  if (process.env.TAMAGUI_TARGET != "web")
    return current;
  const [state, setState] = useState(initialValue);
  useIsomorphicLayoutEffect(() => {
    setState(current);
  }, [current.height, current.width, current.fontScale, current.scale]);
  return state;
}
export {
  useWindowDimensions
};
//# sourceMappingURL=index.mjs.map
